import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { environment } from '../../../../environments/environment'
import { EventCalendarModel } from '../../../core/models/event-calendar.model'

interface requestParamsEvents {
  users?: number[]
  dateFrom?: string
  dateTo?: string
}

@Injectable({
  providedIn: 'root',
})
export class EventsService {
  private planifyApiUrl = environment.planifyApiUrl
  private http = inject(HttpClient)

  constructor() {}

  getEvents(options: requestParamsEvents) {
    return this.http.post<EventCalendarModel[]>(
      `${this.planifyApiUrl}/events/get-for-calendar`,
      options
    )
  }

  getEventsTypes(erpSource: string) {
    return this.http.get(
      `${this.planifyApiUrl}/events-types?erpSource=${erpSource}`
    )
  }

  store(form: any) {
    return this.http.post(`${this.planifyApiUrl}/events`, form)
  }

  storeWithRecurrence(form: any) {
    return this.http.post(`${this.planifyApiUrl}/events-recurrence`, form)
  }

  updateDate(id: number, form: any) {
    return this.http.put(`${this.planifyApiUrl}/events/${id}/update-date`, form)
  }

  shift(id: number, form: any) {
    return this.http.put(`${this.planifyApiUrl}/events/${id}/shift`, form)
  }

  update(id: number, form: any) {
    return this.http.put(`${this.planifyApiUrl}/events/${id}`, form)
  }

  updateWithRecurrence(id: number, form: any) {
    return this.http.put(`${this.planifyApiUrl}/events-recurrence/${id}`, form)
  }

  delete(eventId: number, body: any) {
    return this.http.delete(`${this.planifyApiUrl}/events/${eventId}`, body)
  }

  deleteWithRecurrence(eventId: number, body: any) {
    return this.http.delete(
      `${this.planifyApiUrl}/events-recurrence/${eventId}`,
      body
    )
  }
}
